import { Component, DestroyRef, inject } from '@angular/core';
import { RealtorFormComponent } from '../realtor-form/realtor-form.component';
import { PublicLogSource, PublicLogsService } from '@zayan-erp/shared';
import { map, Subject } from 'rxjs';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'lib-public-realtor',
  standalone: true,
  imports: [RealtorFormComponent, RouterLink],
  templateUrl: './public-realtor.component.html'
})
export class PublicRealtorComponent {
  #publicLogsService = inject(PublicLogsService);
  #destroyRef = inject(DestroyRef);
  private onSubmitButtonClickSubject = new Subject<void>();
  onSubmitButtonClickObservable = this.onSubmitButtonClickSubject.asObservable();

  ngAfterViewInit() {
    this.#publicLogsService
      .postPublicLog(PublicLogSource.RealtorPage, `salesOfficeID=${this.salesOfficeId()}`)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe();
  }

  #route = inject(ActivatedRoute);
  salesOfficeId = toSignal(this.#route.paramMap.pipe(map(params => params.get('salesOfficeId'))), {
    initialValue: null
  });

  onSaveButtonClick() {
    this.onSubmitButtonClickSubject.next();
  }
}
